var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppScreenOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 14.5827H10.0096M6.83464 18.3327H13.168C14.1014 18.3327 14.5681 18.3327 14.9246 18.151C15.2382 17.9912 15.4932 17.7363 15.653 17.4227C15.8346 17.0661 15.8346 16.5994 15.8346 15.666V4.33268C15.8346 3.39926 15.8346 2.93255 15.653 2.57603C15.4932 2.26243 15.2382 2.00746 14.9246 1.84767C14.5681 1.66602 14.1014 1.66602 13.168 1.66602H6.83464C5.90121 1.66602 5.4345 1.66602 5.07798 1.84767C4.76438 2.00746 4.50941 2.26243 4.34962 2.57603C4.16797 2.93255 4.16797 3.39926 4.16797 4.33268V15.666C4.16797 16.5994 4.16797 17.0661 4.34962 17.4227C4.50941 17.7363 4.76438 17.9912 5.07798 18.151C5.4345 18.3327 5.90121 18.3327 6.83464 18.3327ZM10.418 14.5827C10.418 14.8128 10.2314 14.9993 10.0013 14.9993C9.77118 14.9993 9.58464 14.8128 9.58464 14.5827C9.58464 14.3526 9.77118 14.166 10.0013 14.166C10.2314 14.166 10.418 14.3526 10.418 14.5827Z",
    stroke: "#FFA600",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppScreenOrange);
export default __webpack_public_path__ + "static/media/app-screen-orange.00edd393233808db54674c7e756b5697.svg";
export { ForwardRef as ReactComponent };